<template>
  <v-container>
      <v-breadcrumbs v-if="this.$store.getters.breadcrumbs.length > 0" :items="this.$store.getters.breadcrumbs"></v-breadcrumbs>
    <router-view :key="$route.fullPath"></router-view>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  data: function() {
    return {
        icp: require("../assets/img/icp.png"),
        // breadcrumbs:
    };
  },
  created: function() {
    this.getUserAlbums();
  },
  watch: {
    '$route' (to, from) {
      // react to route changes...
    //   console.log('location change', to, from)
    // breadcrumbs.
        const breadcrumbs = this.commonUtils.breadcrumbs(to.path, this);
        console.log('breadcrumbs', breadcrumbs);
        this.$store.commit('setBreadcrumbs', { breadcrumbs });

    }
  },
  methods: {
    getUserAlbums: function() {
      const userUuid = this.$store.getters.userUuid;

      if (userUuid) {
        this.commonUtils.getAlbumsByUuid(userUuid, this).then(response => {
        //   this.albums = this.albums.concat(response);
        //   console.log("userUuid", userUuid, response);
        });
      } else {
          console.log('111');
      }
    },
    createAlbum: function() {
      this.$router.push({
        name: "/home/album_form"
      });

      //   this.commonUtils.toAlbumForm(this);
    },
    uploadSheet: function() {
      this.$router.push({
        name: "album_detail"
      });
    }
  },
  computed: {
    isChina: function() {
      return window.location.host == "creator.17lianqin.cn";
    },
  }
};
</script>

<style scoped>
.title {
  font-size: 20px;
}

.add_sheet_btn {
  background-color: "#DBEBFF";
}
.icp {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto
}
</style>
